import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getColKey as d, getNumberColWidth as M } from "./utils.js";
import { formatLength as j } from "../../_utils/css/format-length.js";
import { beforeNextFrameOnce as k } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/animation/next-frame-once.js";
import { ref as a } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { computed as v, watch as p } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function U(r, {
  mainTableInstRef: h,
  mergedCurrentPageRef: W,
  bodyWidthRef: S
}) {
  let u = 0;
  const f = a(), x = a(null), g = a([]), C = a(null), F = a([]), _ = v(() => j(r.scrollX)), y = v(() => r.columns.filter((e) => e.fixed === "left")), L = v(() => r.columns.filter((e) => e.fixed === "right")), K = v(() => {
    const e = {};
    let l = 0;
    function t(o) {
      o.forEach((n) => {
        const i = {
          start: l,
          end: 0
        };
        e[d(n)] = i, "children" in n ? (t(n.children), i.end = l) : (l += M(n) || 0, i.end = l);
      });
    }
    return t(y.value), e;
  }), H = v(() => {
    const e = {};
    let l = 0;
    function t(o) {
      for (let n = o.length - 1; n >= 0; --n) {
        const i = o[n], c = {
          start: l,
          end: 0
        };
        e[d(i)] = c, "children" in i ? (t(i.children), c.end = l) : (l += M(i) || 0, c.end = l);
      }
    }
    return t(L.value), e;
  });
  function E() {
    var e, l;
    const {
      value: t
    } = y;
    let o = 0;
    const {
      value: n
    } = K;
    let i = null;
    for (let c = 0; c < t.length; ++c) {
      const s = d(t[c]);
      if (u > (((e = n[s]) === null || e === void 0 ? void 0 : e.start) || 0) - o)
        i = s, o = ((l = n[s]) === null || l === void 0 ? void 0 : l.end) || 0;
      else
        break;
    }
    x.value = i;
  }
  function w() {
    g.value = [];
    let e = r.columns.find((l) => d(l) === x.value);
    for (; e && "children" in e; ) {
      const l = e.children.length;
      if (l === 0)
        break;
      const t = e.children[l - 1];
      g.value.push(d(t)), e = t;
    }
  }
  function B() {
    var e, l;
    const {
      value: t
    } = L, o = Number(r.scrollX), {
      value: n
    } = S;
    if (n === null)
      return;
    let i = 0, c = null;
    const {
      value: s
    } = H;
    for (let A = t.length - 1; A >= 0; --A) {
      const R = d(t[A]);
      if (Math.round(u + (((e = s[R]) === null || e === void 0 ? void 0 : e.start) || 0) + n - i) < o)
        c = R, i = ((l = s[R]) === null || l === void 0 ? void 0 : l.end) || 0;
      else
        break;
    }
    C.value = c;
  }
  function N() {
    F.value = [];
    let e = r.columns.find((l) => d(l) === C.value);
    for (; e && "children" in e && e.children.length; ) {
      const l = e.children[0];
      F.value.push(d(l)), e = l;
    }
  }
  function b() {
    const e = h.value ? h.value.getHeaderElement() : null, l = h.value ? h.value.getBodyElement() : null;
    return {
      header: e,
      body: l
    };
  }
  function T() {
    const {
      body: e
    } = b();
    e && (e.scrollTop = 0);
  }
  function X() {
    f.value !== "body" ? k(m) : f.value = void 0;
  }
  function O(e) {
    var l;
    (l = r.onScroll) === null || l === void 0 || l.call(r, e), f.value !== "head" ? k(m) : f.value = void 0;
  }
  function m() {
    const {
      header: e,
      body: l
    } = b();
    if (!l)
      return;
    const {
      value: t
    } = S;
    if (t !== null) {
      if (r.maxHeight || r.flexHeight) {
        if (!e)
          return;
        const o = u - e.scrollLeft;
        f.value = o !== 0 ? "head" : "body", f.value === "head" ? (u = e.scrollLeft, l.scrollLeft = u) : (u = l.scrollLeft, e.scrollLeft = u);
      } else
        u = l.scrollLeft;
      E(), w(), B(), N();
    }
  }
  function P(e) {
    const {
      header: l
    } = b();
    l && (l.scrollLeft = e, m());
  }
  return p(W, () => {
    T();
  }), {
    styleScrollXRef: _,
    fixedColumnLeftMapRef: K,
    fixedColumnRightMapRef: H,
    leftFixedColumnsRef: y,
    rightFixedColumnsRef: L,
    leftActiveFixedColKeyRef: x,
    leftActiveFixedChildrenColKeysRef: g,
    rightActiveFixedColKeyRef: C,
    rightActiveFixedChildrenColKeysRef: F,
    syncScrollState: m,
    handleTableBodyScroll: O,
    handleTableHeaderScroll: X,
    setHeaderScrollLeft: P
  };
}
export {
  U as useScroll
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/use-scroll.js
// module id = 1663
// module chunks = 67